module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAYAAACALL/6AAAAKElEQVQYlWM8cODAfwYSABMpikesBhYYw8HBAauCAwcOUMkGdJNwAQAB6AiXLlrmxgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/MINIMIZE.png
// module id = 85
// module chunks = 0